import moment from 'moment';
import { CheckoutIntegrationStatus } from '../models/CheckoutIntegrationStatus';
import Order from '../models/Order';
import { AppSettings } from '../services/app-settings.service';

export const sleep = (ms: number) => {
	return new Promise(resolve => setTimeout(resolve, ms));
};

export const filterOrders = (orders: Order[], appSettings: AppSettings): Order[] => {
	return orders.filter(order => {
		if (order.checkoutIntegrationStatus === CheckoutIntegrationStatus.CANCELED) {
			return false;
		}

		if (moment().add(90, 'm').isBefore(moment(order.orderAt))) {
			return false;
		}

		if (!appSettings.isShowRefundOn && (!order.totalPrice || Number(order.totalPrice) < 0)) {
			return false;
		}

		return true;
	});
};
